import { render, staticRenderFns } from "./Taxes.vue?vue&type=template&id=08b9f25f"
import script from "./Taxes.vue?vue&type=script&lang=js"
export * from "./Taxes.vue?vue&type=script&lang=js"
import style0 from "./Taxes.vue?vue&type=style&index=0&id=08b9f25f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports